import * as Actions from '../actions/loadNationalities.actions'

const initialState = {
  nationalityList: [],
}

export default function (state = initialState, action) {
  const newState = { ...state }
  switch (action.type) {
    case Actions.GET_NATIONALITIES_SUCCESS: {
      return {
        ...newState,
        nationalityList: [...action.data],
      }
    }
    default: {
      return newState
    }
  }
}
